import { Box, Button, Typography } from '@mui/material';
import { useContent } from 'contexts/Content/Content';
import { usePage } from 'contexts/Page/Page';
import { useTheme } from 'contexts/Theme/Theme';
import { getUrl } from 'helpers';
import { useEffect, useState } from 'react';

export default function Intro({ lesson }: IntroProps) {
    const [heading, setHeading] = useState('');
    const [lessonContent, setLessonContent] = useState<IntroContent | undefined>(undefined);
    const [text, setText] = useState('');
    const [title, setTitle] = useState('');
    const content = useContent();
    const page = usePage();
    const theme = useTheme();

    const pageLesson = lesson || page.lesson;

    useEffect(() => {
        // Get lesson content
        if (pageLesson) {
            // Get lesson content
            const newLessonContent = content.lessons[pageLesson] as IntroContent | undefined;
            setLessonContent(newLessonContent);

            // Parse heading
            const newHeading = newLessonContent?.heading ? content.parseHtml(newLessonContent.heading) : '';
            setHeading(newHeading);

            // Parse text
            const newText = newLessonContent?.text ? content.parseHtml(newLessonContent.text) : '';
            setText(newText);

            // Parse title
            const newTitle = newLessonContent?.title ? content.parseHtml(newLessonContent.title) : '';
            setTitle(newTitle);
        }
    }, [content, pageLesson]);

    return (
        <Box
            sx={{
                background: `url(${getUrl('/assets/illustrations/intro-background.png')})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                borderRadius: 5,
                padding: 3,
                textAlign: 'center',
            }}
        >
            <Typography
                color={theme.darkMode ? '#FFF' : '#141414'}
                marginBottom={2}
                paragraph
                textTransform="uppercase"
                variant="montserrat720"
            >
                {heading}
            </Typography>
            <Typography
                color={theme.darkMode ? '#FFF' : '#1375BC'}
                dangerouslySetInnerHTML={{ __html: title }}
                component="h1"
                marginBottom={5}
                variant="montserrat730"
            />
            <Typography
                align="center"
                component="div"
                dangerouslySetInnerHTML={{ __html: text }}
                marginBottom={8}
                marginX="auto"
                maxWidth={400}
                variant="montserrat524"
            />
            <Button size="large" onClick={() => page.show(`${pageLesson}.1`)}>
                {lessonContent?.primaryButton}
            </Button>
            {lessonContent?.secondaryButton && (
                <Box marginTop={2}>
                    <Button color="secondary" size="large" onClick={() => page.show('1.1')}>
                        {lessonContent.secondaryButton}
                    </Button>
                </Box>
            )}
            {lessonContent?.image && (
                <Box marginX="auto" marginTop={8} maxWidth={360} width="100%">
                    <picture>
                        <img
                            alt={lessonContent?.imageAlt ?? ''}
                            src={getUrl(lessonContent.image)}
                            style={{ maxWidth: '100%' }}
                        />
                    </picture>
                </Box>
            )}
        </Box>
    );
}
